import { Icon } from '@mage-ui/components';
import {
  icon,
  modalBody,
  modalClose,
  modalContent,
  modalInner,
  modalOverlay,
  modalRoot,
  text,
} from '@mage-ui/styled-system/recipes';
import { Modal as MantineModal } from '@mantine/core';

export const Modal = ({ children, opened, onClose, texts }) => {
  return (
    <>
      <MantineModal
        opened={opened}
        onClose={onClose}
        withCloseButton={true}
        closeButtonProps={{
          icon: (
            <>
              {texts?.close && (
                <span className={text({ size: '4', weight: 'medium' })}>
                  {texts?.close}
                </span>
              )}
              <Icon
                name='disabled_by_default'
                classNames={icon({ size: 'm' })}
              />
            </>
          ),
        }}
        classNames={{
          root: modalRoot(),
          inner: modalInner(),
          content: modalContent(),
          overlay: modalOverlay(),
          body: modalBody(),
          close: modalClose(),
        }}
      >
        {children}
      </MantineModal>
    </>
  );
};
